/**
 * @generated SignedSource<<0869361334940ba6ece22f58b0b868f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamType = "CHECKOUT" | "FLOOR";
export type PLUCategoryEditQuery$variables = {
  id: string;
};
export type PLUCategoryEditQuery$data = {
  readonly pluCategories: ReadonlyArray<{
    readonly color: string;
    readonly id: string;
  }>;
  readonly pluCategory: {
    readonly color: string;
    readonly id: string;
    readonly teamsFilter: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly title: string;
  } | null;
  readonly store: {
    readonly publicTeams: ReadonlyArray<{
      readonly id: string;
      readonly type: TeamType;
      readonly " $fragmentSpreads": FragmentRefs<"TeamSelectListItem_Team">;
    }>;
  };
};
export type PLUCategoryEditQuery = {
  response: PLUCategoryEditQuery$data;
  variables: PLUCategoryEditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "PLUCategory",
  "kind": "LinkedField",
  "name": "pluCategory",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teamsFilter",
      "plural": true,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PLUCategory",
  "kind": "LinkedField",
  "name": "pluCategories",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUCategoryEditQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamSelectListItem_Team"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PLUCategoryEditQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ]
  },
  "params": {
    "cacheID": "f0c3b551a8a89bd5e6658d72938910c7",
    "id": null,
    "metadata": {},
    "name": "PLUCategoryEditQuery",
    "operationKind": "query",
    "text": "query PLUCategoryEditQuery(\n  $id: ID!\n) {\n  pluCategory(id: $id) {\n    id\n    color\n    title\n    teamsFilter {\n      id\n    }\n  }\n  store {\n    publicTeams {\n      id\n      type\n      ...TeamSelectListItem_Team\n    }\n    id\n  }\n  pluCategories {\n    id\n    color\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n"
  }
};
})();

(node as any).hash = "121c435694c5fce2bf64d0ce8e056e6d";

export default node;
